import React from 'react'

const MoreDetails = function(props) {
  function handleClick(event) {
    let link = event.target
    let content = link.parentElement.previousSibling

    content.classList.remove('ellipsis')
    link.classList.add('hidden')
  }

  return (
    <a
      className="flat-link-gray bold text-copy-1"
      id={props.linkId}
      href="javascript:void(0)"
      onClick={handleClick}>
      {props.linkText || 'Show more'}
    </a>
  )
}

export default MoreDetails
